import { useQuery } from '@tanstack/react-query';
import backend, { type ServerStatus } from '../services/backend';

export function useServerFeatures(): ServerStatus['features'] | null {
  const { data } = useQuery({
    queryKey: ['serverStatus'],
    queryFn: () => backend.getStatus().then((res) => res.data),
    staleTime: 5 * 60 * 1000,
  });
  return data?.features ?? null;
}
